export type Browser = 'Chrome' | 'Safari' | 'Firefox';

/**
 * Получение названия используемого браузера
 * @returns browserName - название используемого браузера
 */
export function getCurrentBrowser(): Browser | undefined {
    const userAgent = typeof window !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
    let browserName: Browser | undefined = undefined;

    if (userAgent.match(/chrome|chromium|crios/i)) {
        browserName = 'Chrome';
    } else if (userAgent.match(/firefox|fxios/i)) {
        browserName = 'Firefox';
    } else if (userAgent.match(/safari/i)) {
        browserName = 'Safari';
    }

    return browserName;
}
